(function() {
    const getClosestListWithChildren = function(el) {
        if(!el) return null;

        return el.parentNode ? el.parentNode.closest(".wc-block-product-categories-list-item--has-children") : null;
    };
    const getAncestorsWithChildren = function(el, ancestors) {
        if(typeof ancestors === "undefined") {
            ancestors = [];
        }

        const tmp = getClosestListWithChildren(el);
        
        if(!tmp) {
            return ancestors;
        }

        ancestors.push(tmp);

        return getAncestorsWithChildren(tmp, ancestors);
    };

    /** 
     * Identify product categories list-item with children and create buttons to toggle 
     * their display in WooCommerce `woocommerce/product-categories` block
     */ 
    const catListItems = document.querySelectorAll(".wc-block-product-categories-list.wc-block-product-categories-list--depth-0 .wc-block-product-categories-list-item");

    if(catListItems.length) {
        catListItems.forEach(function(listItem) {
            const subCatList = listItem.querySelector(".wc-block-product-categories-list");
            
            if(subCatList) {
                listItem.classList.add("wc-block-product-categories-list-item--has-children");
                
                const subCatDisplayButton = document.createElement("button");
                subCatDisplayButton.type = "button";
                subCatDisplayButton.classList.add("wc-block-product-categories-toggle-subcat-button");
                listItem.append(subCatDisplayButton);
            }
        });
    }

    // Bind product categories list toggle buttons to toggle in WooCommerce `woocommerce/product-categories` block 
    const subCatDisplayButtons = document.querySelectorAll(".wc-block-product-categories-toggle-subcat-button");

    if(subCatDisplayButtons.length) {
        subCatDisplayButtons.forEach(function(button) {
            button.addEventListener("click", function(e) {
                e.preventDefault();
                button.parentNode.classList.toggle("wc-block-product-categories-list-item--opened");
            }, false);
        });
    }

    // Highlight current category in WooCommerce `woocommerce/product-categories` block
    const currentCatLink = document.querySelector(`.wc-block-product-categories-list-item > a[href="${window.location.href}"]`);
    const currentCatListItem = currentCatLink ? currentCatLink.parentNode : null;

    if(currentCatListItem) {
        currentCatListItem.classList.add("wc-block-product-categories-list-item--current", "wc-block-product-categories-list-item--opened");

        const ancestors = getAncestorsWithChildren(currentCatListItem);
        
        if(ancestors.length) {
            ancestors.forEach(function(ancestor) {
                ancestor.classList.add("wc-block-product-categories-list-item--opened");
            });
        }
    }
})();